module.exports = __webpack_public_path__ + "static/media/Christianity1A.00301ecd.png";